const API_BASE_URL = 'https://natcopharmacy.com/backend';

export const fetchProducts = async (search = '', category = '') => {
  try {
    const queryParams = new URLSearchParams();
    if (search) queryParams.append('search', search);
    if (category) queryParams.append('category', category);

    const response = await fetch(`${API_BASE_URL}/get_products?${queryParams}`);
    const data = await response.json();

    // Check if data is in the expected format
    if (!data || data.status === 'error') {
      throw new Error(data?.message || 'Failed to fetch products');
    }

    // Ensure we return an array
    return Array.isArray(data) ? data : data.data || [];
  } catch (error) {
    console.error('Error fetching products:', error);
    throw error;
  }
};

export const verifyProduct = async (code) => {
  try {
    const response = await fetch(`${API_BASE_URL}/verify_product`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ code }),
    });

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error verifying product:', error);
    throw error;
  }
};
